<template>
  <!-- 选择专业 author: zhangxiaofeng-->
  <div class="select-major__wrapper relative">
    <!-- 专业备选区域 -->
    <div class="select-major">
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
        <tr v-for="(trItem, index) in majorList" :key="'tr_' + index" :class="index > 0 ? (showMore ? '' : 'more') : ''">
          <th width="85" rowspan="3" v-if="index === 0">选择专业：</th>
          <td width="10.5%" v-for="(tdItem, idx) in trItem" :key="'tr_' + index + '_td_' + idx"
              :class="tdItem.children && tdItem.children.length ? 'hasChildren' : ''">
            <template v-if="tdItem.catalogIdGuid">
              <div :class="['major-list major-click']"
                   @click="selectMajor(tdItem.catalogIdGuid, false, tdItem)"
                   :catalogidguid = "tdItem.catalogIdGuid" :description="tdItem.description">
                <em :class="'icon' + majorIcon[tdItem.description]"></em>
                {{tdItem.description}}
              </div>
              <i></i>
              <div class="major-list_box" v-if="tdItem.children && tdItem.children.length">
                <w-scrollbar wrap-style="overflow-x: hidden;" style="width: 100%;height: 260px;overflow-x: hidden;">
                  <a v-for="(tdChild, i) in tdItem.children"
                     :class="['major-item', majorSelected[tdChild.catalogIdGuid] ? 'selected' : '']"
                     @click="selectMajor(tdChild.catalogIdGuid, false, tdChild, true)"
                     :key="'tr_' + index + '_td_' + idx + '_child_' + i"
                     :catalogidguid="tdChild.catalogIdGuid"
                     :description="tdChild.description"
                     :id="'major-list-a-' + tdChild.catalogIdGuid" >
                    <i class="w-icon-tijiao"></i>
                    {{tdChild.description}}
                  </a>
                </w-scrollbar>
              </div>
            </template>
            <div v-else class="major-other"></div>
          </td>
          <td v-if="index === 0">
            <div class="major-other" style="border-top: none;">
              <a v-if="majorList.length > 1" class="switch-btn js-major-norm" @click="showMoreMajor" >
                <template v-if="!showMore">
                  <em>更多</em>
                  <i class="w-icon-xiala"></i>
                </template>
                <template v-else>
                  <em>收起</em>
                  <i class="w-icon-xiala-copy"></i>
                </template>
              </a>
              <multiple-select v-if="majorFetched" :list="majorLongList"
                               name="major"
                               value="catalogIdGuid"
                               label="description"
                               :selected="catalogIdGuidSelected"
                               @change="multipleSelectChange"
                               :parent-region="parentRegion"
                               :refresh-index="refreshIndex">
              </multiple-select>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <Collapse>
      <div v-show="!foldArea">
        <!-- 选择地区 -->
        <div class="select-area">
          <table width="100%" cellspacing="0" cellpadding="0">
            <tbody>
            <tr>
              <th width="85">选择地区：</th>
              <td>
                <div class="area-content">
                  <select  v-if="regionList.length" class="region-select"
                           @change="changeHandle()" v-model="regionSelected">
                    <option v-for="(region, idx) in regionList"
                            :key="'region_option_' + idx"
                            :value="region">
                      {{region}}
                    </option>
                  </select>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="select-qd" v-if="page === 'Combination'">
          <table width="100%" cellspacing="0" cellpadding="0">
            <tbody>
            <tr>
              <th width="85">清单库：</th>
              <td>
                <div class="qd-content">
                  <a href="javascript: void(0);"
                     v-for="(item, idx) in inventoryList"
                     :key="'select_inventory_' + idx"
                     @click="selectInventoryQuota(item, 'inventory')">
                    {{item}}
                  </a>
                </div>
              </td>
              <td width="185">
                <multiple-select :list="inventoryList"
                                 name="inventory"
                                 :selected="inventorySelectArr"
                                 @change="multipleSelectChange"
                                 :refresh-index="refreshIndex"
                                 simple>
                </multiple-select>
              </td>
            </tr>
            <tr>
              <th width="85">定额库：</th>
              <td>
                <div class="qd-content">
                  <a href="javascript: void(0);"
                     v-for="(item, idx) in quotaList"
                     :key="'select_quota_' + idx"
                     @click="selectInventoryQuota(item, 'quota')">
                    {{item}}
                  </a>
                </div>
              </td>
              <td width="185">
                <multiple-select :list="quotaList"
                                 name="quota"
                                 :selected="quotaSelectArr"
                                 @change="multipleSelectChange"
                                 :refresh-index="refreshIndex"
                                 simple>
                </multiple-select>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <!-- 已选择 -->
        <div class="select-view" v-if="majorSelectArr.length || inventorySelectArr.length || quotaSelectArr.length">
          <table width="100%" cellspacing="0" cellpadding="0">
            <tbody>
            <tr>
              <th width="85">已选择：</th>
              <td>
                <div class="select-view_content">
                  <div style="display: inline;">
                    <label>
                      <!-- 已选择的专业 -->
                      <span v-for="(selectItem, idx) in majorSelectArr" :key="'major-selected-' + idx">
                    {{selectItem.description}}
                    <a class="w-icon-quxiao2-copy" @click="selectMajor(selectItem.catalogIdGuid, true)" title="删除"></a>
                  </span>

                      <!-- 已选择的清单 -->
                      <span v-for="(item, idx) in inventorySelectArr" :key="'inventory-selected-' + idx">
                    {{item}}
                    <a class="w-icon-quxiao2-copy" @click="selectInventoryQuota(item, 'inventory', true)" title="删除"></a>
                  </span>

                      <!-- 已选择的定额 -->
                      <span v-for="(item, idx) in quotaSelectArr" :key="'quota-selected-' + idx">
                    {{item}}
                    <a class="w-icon-quxiao2-copy" @click="selectInventoryQuota(item, 'quota', true)" title="删除"></a>
                  </span>

                    </label>

                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Collapse>
    <!--折叠按钮-->
    <el-tooltip :content="foldArea ? '展开' : '收起'">
      <div class="foldIcon" @click="changeFoldStatus()">
        <i class="r2-icon-nav_expand_more" style="color: rgba(33, 37, 48, 0.55);" v-if="foldArea"></i>
        <i class="r2-icon-nav_expand_less" style="color: rgba(33, 37, 48, 0.55);" v-else></i>
      </div>
    </el-tooltip>
  </div>
</template>
<script>
// import Bus from '@/assets/utils/bus';
import api from 'service'
import {capitalize, pilesArr} from '@/assets/utils'
import { getCookie, delCookie } from '@/assets/utils/CommonUtil'
import {mapActions} from 'vuex'
import MultipleSelect from './MultipleSelect'
import Collapse from './Collapse/Index'
// 工程 - icon 映射
const majorIcon = {
  '建筑、装饰工程': 1,
  '建筑工程': 1,
  '仿古建筑工程': 2,
  '仿古工程': 2,
  '安装工程': 3,
  '市政工程': 4,
  '园林绿化工程': 5,
  '园林工程': 5,
  '构筑物工程': 6,
  '城市轨道交通工程': 7,
  '轨道交通': 7,
  '矿山工程': 8,
  '爆破工程': 9,
  '房修土建结构工程': 10,
  '房修装饰装修工程': 11,
  '房修安装工程': 12,
  '房修古建筑工程': 13,
  '房修市政工程': 14,
  '装饰工程': 15,
  '其他': 16,
  '人工': 17,
  '材料': 18,
  '主材': 19,
  '设备': 20,
  '机械': 21,
  '绿色建筑工程': 22,
  '装配式建筑工程': 23
}
export default {
  name: 'OperationSelectMajor',
  props: {
    refreshRegionList: {
      type: Number,
      default: 0
    },
    inventoryQuotaListChanged: {
      type: Number,
      default: 0
    },
    inventoryList: {
      type: Array,
      default: () => [] // 清单列表 ['08清单', '09清单']
    },
    quotaList: {
      type: Array,
      default: () => [] // 定额列表 ['10序列']
    },
    parentRegion: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      foldArea: false,
      regionList: [], // 地区列表
      regionSelected: '', // 已选择的地区
      majorIcon,
      showMore: false, // 显示第二行、第三行 ... 专业
      inventorySelectArr: [], // 已选择 清单列表
      quotaSelectArr: [], // 已选择 定额列表
      majorList: [[]],
      majorLongList: [],
      majorSelectArr: [],
      catalogIdGuidSelected: [],
      majorSelected: {}, // 已选择的专业 对象
      majorFetched: false, // 专业数据是否已获取
      refreshIndex: 0,
      user: {}
    }
  },
  computed: {
    page () {
      const path = this.$route.path
      let page = ''
      // 电子档案室 -> 企业造价数据 ->
      let reg = /^\/database\/basis\/((inventory)|(combination)|(quota)|(material))\/?/
      // 员工资料库 -> 员工数据 ->
      if (/^\/space\/database\//.test(path)) {
        reg = /^\/space\/database\/((inventory)|(combination)|(quota)|(material))\/?/
      }
      const matchArr = reg.exec(path)
      if (matchArr && matchArr.length > 1) {
        page = capitalize(matchArr[1])
      }
      return page
    }
  },
  created () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo){
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    this.initMajorAndRegion()
    // Bus.$on('uploadAll', (file) => {
    //   this.getMajorAndRegion()
    // });
  },
  methods: {
    ...mapActions({
      getMajorAndRegion: 'database/getMajorAndRegion'
    }),
    // 清空已选择
    clearSelect (type, multiple) {
      switch (type) {
        case 'init':
          this.majorSelectArr = []
          this.catalogIdGuidSelected = []
          this.inventorySelectArr = []
          this.quotaSelectArr = []
          break
        case 'major':
          this.majorSelectArr = []
          this.catalogIdGuidSelected = []
          if (!multiple) {
            this.inventorySelectArr = []
            this.quotaSelectArr = []
          }
          break
        case 'inventory':
        case 'quota':
          break
        default:
      }
    },
    // 1. 获取所有的专业章节及地区等信息
    initMajorAndRegion () {
      this.showMore = false
      this.majorSelected = {}
      this.clearSelect('init')
      let completion = true // 是否补全 行
      if (this.page) {
        if (this.page === 'Material') {
          completion = false
        }
        const listDataReady = (list) => {
          this.majorLongList = list
          if (list.length) {
            this.majorList = pilesArr(list, 7, completion, {})
          } else {
            this.majorList = [[]]
          }
        }
        this.getMajorAndRegion(capitalize(this.page, true)).then((data) => {
          const list = data.catalogList || []
          listDataReady(list)
          this.regionList = data.regionList || []
          this.setDefaultRegion()
          this.majorFetched = true
        }).catch((e) => {
          console.log(e)
          this.majorFetched = true
        })
      }
    },
    // 2 选择/取消选择 清单、定额
    selectInventoryQuota (item, type, multiple) {
      if (!multiple) {
        // this.clearSelect();
        this[type + 'SelectArr'] = [item]
      } else {
        this[type + 'SelectArr'].forEach((value, idx) => {
          if (value === item) {
            this.$delete(this[type + 'SelectArr'], idx)
          }
        })
      }
      this.changeHandle(type)
      this.refreshIndex++
    },
    // 3. 选择/取消选择 专业
    selectMajor (catalogIdGuid, multiple, item, isChapter) {
      if (!multiple) {
        // 单选
        for (const key in this.majorSelected) {
          if (key !== catalogIdGuid) {
            this.$delete(this.majorSelected, key)
          }
        }
        this.$set(this.majorSelected, catalogIdGuid, true)
        this.inventorySelectArr = []
        this.quotaSelectArr = []
      } else if (this.majorSelected[catalogIdGuid]){
        // 已选择列表 取消选择 某一个
        this.$delete(this.majorSelected, catalogIdGuid)
      }
      this.clearSelect('major', multiple)
      for (const key in this.majorSelected) {
        this.findSelectMajor(key)
      }
      this.refreshIndex++
      this.getRegionList()
    },
    // 3.1 多选操作
    multipleSelectChange (list, type) {
      this.clearSelect(type, true)
      switch (type) {
        case 'major':
          console.log(list)
          for (const key in this.majorSelected) {
            this.$delete(this.majorSelected, key)
          }
          list.forEach((item) => {
            this.$set(this.majorSelected, item, true)
          })
          for (const key in this.majorSelected) {
            this.findSelectMajor(key)
          }
          this.getRegionList()
          break
        case 'inventory':
        case 'quota':
          this[type + 'SelectArr'] = list
          this.changeHandle(type)
          break
        default:
      }
      this.refreshIndex++
    },
    // 3.2 寻找已选择的专业 存放到数组中
    findSelectMajor (key, list) {
      const nowList = list || this.majorLongList
      for (let i = 0; i < nowList.length; i++) {
        if (nowList[i].catalogIdGuid === key) {
          this.$set(this.majorSelectArr, this.majorSelectArr.length, nowList[i])
          this.$set(this.catalogIdGuidSelected, this.catalogIdGuidSelected.length, nowList[i].catalogIdGuid)
          break
        } else {
          if (nowList[i].children && nowList[i].children.length) {
            this.findSelectMajor(key, nowList[i].children)
          }
        }
      }
    },
    // 3.3 更多/收起 点击
    showMoreMajor () {
      this.showMore = !this.showMore
      setTimeout(() => {
        this.$emit('operateMoreMajor', this.showMore)
      }, 300)
    },
    changeFoldStatus () {
      this.foldArea = !this.foldArea
      setTimeout(() => {
        this.$emit('operateMoreMajor', this.showMore)
      }, 300)
    },
    // 4. 根据专业 获取地区列表
    getRegionList () {
      const params = {
        catalogIdGuid: this.catalogIdGuidSelected.join(',')
      }
      api[capitalize(this.page, true)].getRegions(params).then((data) => {
        // console.log(data)
        // console.log('-=-=-=-=')
        if (+data.code === 200) {
          this.regionList = data.data || []
          this.setDefaultRegion()
        }
      })
    },
    // 4.1 地区列表变化时 设置默认选中项
    setDefaultRegion () {
      if (this.regionList.length) {
        let regionInArr = false
        let region = this.regionSelected
        // 浏览器记录上一次选择
        // 处理p5端跳转，设置默认地区
        let P5Region = getCookie('DATAREGION')
        if (P5Region && P5Region.length) {
          region = decodeURIComponent(P5Region)
          delCookie('DATAREGION')
        } else {
          if (this.parentRegion) {
            // 区分用户 解决一次会话 切换用户 登录后 地区下拉框反显不正确的问题
            const data = sessionStorage.getItem(this.parentRegion + '_' + this.user.gldUserId)
            if (data && data.length){
              region = data
            }
          }
        }
        this.regionList.forEach((item) => {
          if (region === item) {
            regionInArr = true
            this.regionSelected = item
          }
        })
        // 如果 获取到了P5跳转的地区 并且在当前地区列表里匹配到了 就不往下执行
        if (!regionInArr){
          this.regionSelected = this.regionList[0]
        }
        this.changeHandle('region')
      } else {
        this.changeHandle('region')
      }
    },
    // 5. 切换地区时
    changeHandle (type) {
      // dbidsStr: 08清单
      this.$emit('change', {
        changeType: type || 'region',
        region: this.regionSelected,
        major: this.catalogIdGuidSelected.join(','),
        dbidsStr: this.inventorySelectArr.join(','), // 清单
        seriesStr: this.quotaSelectArr.join(',')
      })
    },
    // 6. 当 清单列表、定额列表改变时 实时修改已选择的 清单、定额
    resetSelectedInventoryQuota () {
      const arr = ['inventory', 'quota']
      const findData = (type) => {
        let i = 0
        while (i < this[type + 'SelectArr'].length) {
          // 如果已选择的 清单/定额 新的列表中存在 已选择栏 不删除
          if (this[type + 'List'].indexOf(this[type + 'SelectArr'][i]) > -1) {
            i++
          } else {
            // 如果已选择的 清单/定额 新的列表中 不存在 已选择栏 删除
            this.$delete(this[type + 'SelectArr'], i)
            continue
          }
        }
      }
      arr.forEach((type) => {
        findData(type)
      })
      this.changeHandle('inventory')
    }
  },
  watch: {
    '$route.path': function () {
      this.initMajorAndRegion()
    },
    'refreshRegionList': function () {
      if (!this.regionList.length) {
        // 如果初始时地区列表为空
        this.initMajorAndRegion()
        return
      }
      if (this.page) {
        this.getMajorAndRegion(capitalize(this.page, true)).then((data) => {
          this.regionList = data.regionList || []
          if (this.regionList.length &&
            (!this.regionSelected || (this.regionSelected && this.regionList.indexOf(this.regionSelected) < 0))) {
            this.regionSelected = this.regionList[0]
            this.changeHandle('region')
          }
        })
      }
    },
    'inventoryQuotaListChanged': function () {
      this.resetSelectedInventoryQuota()
    }
  },
  components: {
    MultipleSelect,
    Collapse
  }
}
</script>
<style lang="less" type="text/less">
  @import "../../assets/less/selectMajor";
</style>
